// extracted by mini-css-extract-plugin
module.exports = {"fullHeight":"QuotesLoader_fullHeight__117rs","quoteLoader":"QuotesLoader_quoteLoader__cfPv8","text":"QuotesLoader_text__3-eyN","name":"QuotesLoader_name__29M4H"};